export const menuItems = [
	{ label: "Home", href: "/" },
	{ label: "About", href: "/about" },
	{ label: "Our Impact", href: "/portfolio" },
	{ label: "Blog", href: "/blog" },
	{ label: "Contact", href: "/contact" },
];

export const socialLinks = [
	{ label: "Instagram", href: "/#" },
	{ label: "Twitter", href: "/#" },
	{ label: "LinkedIn", href: "/#" },
];
